import React, { useEffect, useState } from 'react';
import IncludeExcludeSelected from '../../components/IncludeExcludeSelected';
import { UrlAnalysisSelectType } from '../../types';
import useGetRequest from '../../hooks/useGetRequest';
import { getOpinionGamesContentUrl } from '@/pages/opinion/services';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';
import { NO_DATE } from '@op/constants';

export default function UrlAnalysisSelect({
  gameInfo,
  params,
  collectionCallback,
  ...props
}: UrlAnalysisSelectType) {
  // const [timeParams, setTimeParams] = useState<
  //   | {
  //       start_time: string;
  //       end_time: string;
  //       date_type: string;
  //     }
  //   | undefined
  // >(undefined);

  // useEffect(() => {
  //   collectionCallback?.('urlAnalysis', (value: any) => setTimeParams(value), [
  //     'date',
  //   ]);
  // }, []);

  const {
    loading,
    basicOptions,
    clearOptions,
    debounceGetFilterList,
    setLoading,
    changeBasicOptions,
  } = useGetRequest({
    gameInfo,
    params,
    // timeParams,
    requestFunc: getOpinionGamesContentUrl,
    singleKey: 'search_content',
    hasMultiple: false,
    defaultLoading: false,
  });

  return (
    <div className="url-analysis-select-wrapper">
      <IncludeExcludeSelected
        className="dbo-include-exclude-select--two-line"
        changeBasicOptions={changeBasicOptions}
        clearOptions={clearOptions}
        loading={loading}
        hasBubble
        setLoading={setLoading}
        basicOptions={basicOptions}
        getFilterList={debounceGetFilterList}
        resultKey={'urlAnalysis'}
        includeKey="content_urls"
        excludeKey="exclude_content_urls"
        placeholderKey="urlAnalysis"
        loadingText={NO_DATE.EMPTY}
        placeholderText="Please search and then select a URL"
        topTips={NO_DATE.EMPTY}
        mainText="URL"
        allFilterTips={null}
        hasAllBtn={false}
        returnType="value"
        {...props}
        pointKey={FilterButtonPoint.urlAnalysis}
      ></IncludeExcludeSelected>
    </div>
  );
}
